import type { RefObject } from 'react'

import { Popover } from '../Popover'
import type { PopoverSide } from '../Popover/types'
import { UnsplashImageSearchFooter } from './components/UnsplashImageSearchFooter'
import { UnsplashImageSearchHeader } from './components/UnsplashImageSearchHeader'
import { UnsplashImageSearchProvider } from './UnsplashImageSearchContext'
import { UnsplashImageSearchResults } from './components/UnsplashImageSearchResults'

type UnsplashImageSearchProps = {
  readonly onSelect: (file: File) => void
  readonly trigger?: React.ReactElement
  readonly open: boolean
  readonly onOpenChange: (open: boolean) => void
  readonly virtualRef?: RefObject<HTMLButtonElement | null>
  readonly sideOffset?: number
  readonly side?: PopoverSide
}

export function UnsplashImageSearch({
  onSelect,
  trigger,
  open: isOpen,
  onOpenChange: setIsOpen,
  virtualRef,
  sideOffset = 30,
  side = 'right',
}: UnsplashImageSearchProps) {
  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      className="unsplash-search-popover"
      side={side}
      trigger={trigger}
      virtualRef={virtualRef}
      sideOffset={sideOffset}
      avoidCollisions
      usePortal
      zIndex={2}
    >
      <UnsplashImageSearchProvider onSelect={onSelect} onClose={() => setIsOpen(false)}>
        <div className="unsplash-search-container">
          <UnsplashImageSearchHeader />
          <UnsplashImageSearchResults />
          <UnsplashImageSearchFooter />
        </div>
      </UnsplashImageSearchProvider>
    </Popover>
  )
}
